import { createFileRoute } from '@tanstack/react-router';
import { SlotSettingsScreen } from '../features/settings/SlotSettings.tsx';

export const Route = createFileRoute('/settings_/slots')({ component: SlotSettingsScreen });
